export const appHead = {"meta":[{"charset":"utf-8"},{"name":"theme-color","content":"#FFFFFF"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow, noodp"},{"name":"googlebot","content":"index, follow"},{"name":"format-detection","content":"telephone=no"},{"name":"description","content":"Thai Airways Generative AI Backoffice Admin Panel"},{"name":"keywords","content":""}],"link":[{"rel":"manifest","href":"/manifest.json"},{"rel":"shortcut icon","href":"/favicons/favicon.ico"},{"rel":"icon","sizes":"32x32","type":"image/ico","href":"/favicons/favicon.ico"},{"rel":"icon","sizes":"48x48","type":"image/png","href":"/favicons/favicon@xs.png"},{"rel":"icon","sizes":"96x96","type":"image/png","href":"/favicons/favicon@sm.png"},{"rel":"icon","sizes":"144x144","type":"image/png","href":"/favicons/favicon@md.png"},{"rel":"icon","sizes":"192x192","type":"image/png","href":"/favicons/favicon@lg.png"},{"rel":"apple-touch-icon","href":"/favicons/touch-icon-iphone.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/favicons/touch-icon-ipad.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/favicons/touch-icon-iphone-retina.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/favicons/touch-icon-ipad-retina.png"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@400;500;700&family=Athiti:wght@300;400;500;600;700&display=swap"}],"style":[],"script":[],"noscript":[],"title":"AI Assistant Social Listening Admin Panel"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"